import { Link } from "react-router-dom";
import { FaTrash, FaMinus, FaPlus, FaShoppingCart } from "react-icons/fa";
import PageHeader from "../../components/layout/PageHeader";
import { useShop } from "../../context/ShopContext";

export default function Cart() {
  const { cart, updateQty, removeFromCart, cartTotal } = useShop();

  return (
    <>
      <PageHeader title="Shopping Cart" crumbs={[{ label: "Cart" }]} />
      <section className="section">
        <div className="container">
          {cart.length === 0 ? (
            <div className="empty-state">
              <div className="ei"><FaShoppingCart /></div>
              <h3>Your Cart is Empty</h3>
              <p>Looks like you haven't added anything yet.</p>
              <Link to="/shop-grid" className="btn btn-primary">Continue Shopping</Link>
            </div>
          ) : (
            <div className="cart-layout">
              <div style={{ overflowX: "auto" }}>
                <table className="cart-table">
                  <thead>
                    <tr>
                      <th>Product</th>
                      <th>Price</th>
                      <th>Quantity</th>
                      <th>Subtotal</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {cart.map((item) => (
                      <tr key={item.id}>
                        <td>
                          <Link to={`/shop/${item.id}`} className="cart-prod">
                            <img src={item.image} alt={item.name} />
                            <span>{item.name}</span>
                          </Link>
                        </td>
                        <td>${item.price.toFixed(2)}</td>
                        <td>
                          <div className="qty-box">
                            <button onClick={() => updateQty(item.id, item.qty - 1)}><FaMinus /></button>
                            <span>{item.qty}</span>
                            <button onClick={() => updateQty(item.id, item.qty + 1)}><FaPlus /></button>
                          </div>
                        </td>
                        <td className="text-yellow">${(item.price * item.qty).toFixed(2)}</td>
                        <td>
                          <button className="cart-remove" onClick={() => removeFromCart(item.id)}>
                            <FaTrash />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="cart-summary">
                <h3>Cart Totals</h3>
                <div className="summary-row"><span>Subtotal</span><span>${cartTotal.toFixed(2)}</span></div>
                <div className="summary-row"><span>Shipping</span><span>Free</span></div>
                <div className="summary-row"><span>Tax (5%)</span><span>${(cartTotal * 0.05).toFixed(2)}</span></div>
                <div className="summary-row total"><span>Total</span><span>${(cartTotal * 1.05).toFixed(2)}</span></div>
                <Link to="/checkout" className="btn btn-primary btn-block mt-3">Proceed to Checkout</Link>
                <Link to="/shop-grid" className="btn btn-outline btn-block mt-2">Continue Shopping</Link>
              </div>
            </div>
          )}
        </div>
      </section>
    </>
  );
}
